<template>
  <div class="page-header">
    <b-container class="page-header-container">
      <router-link class="main-link" :to="{name:'Home'}">Self-Paced Center</router-link>
      <nav class="nav-top">
        <ul class="nav">
          <li class="nav-item" v-for="(info, courseId) in courses" :key="courseId">
            <router-link class="nav-top-link"
                         :class="{ 'router-link-active' : $route.params['courseId'] === courseId}"
                         :to="{name:'Calendar', params: { courseId: courseId }}">
              {{ info.name }}
            </router-link>
          </li>
        </ul>
      </nav>
    </b-container>
  </div>
</template>

<script>
import courses from 'components/courses/settings'

export default {
  name: 'PageHeader',
  data () {
    return {
      courses: courses
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import "~assets/colors.styl"

  a {
    color white
    text-decoration none
    &:hover, &:active {
      color #aaa
    }
  }

  .page-header {
    background-color $blue-chambray
    color white

    .page-header-container {
      display flex
      flex-direction row
      @media (max-width 991px) {
        & {
          flex-direction column
        }
      }
      .main-link {
        flex-shrink 0
        font-size 20px
        font-weight 500
        margin 7px 0
      }
      .nav-top {
        flex-grow 1
        .nav {
          list-style-type none
          padding 0
          margin-left 40px

          @media (max-width 991px) {
            & {
              margin 0 auto
              text-align center
              display inline-block
            }
          }

        }
        .nav-item {
          display inline
          .nav-top-link {
            display inline-block
            padding 10px 30px
            @media (max-width 991px) {
              & {
                padding 7px 20px
              }
            }

            &.router-link-active{
              font-weight 900
              &:hover, &:active {
                color white
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/global/NavBar.vue